import type * as Types from 'web-app/react/test-child-actions/types';
import {makeReducer, match} from 'web-app/util/redux';

import {close, open} from '../types';
import * as Actions from './actions';

export default makeReducer<Types.TestChildActionsModalState>(
    [
        match(Actions.showTestChildActionsModal, (_, {payload}) =>
            open<Types.TestChildActionsModalPayload>({
                ...payload,
            }),
        ),
        match(Actions.hideTestChildActionsModal, () => close()),
    ],
    close(),
);
